import { forwardRef } from 'react';

import { InputLabel as StyledInputLabel } from './InputLabel.styled';
import { InputLabelProps } from './InputLabel.types';

export const InputLabel = forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ hiddenLabel = false, ...props }: InputLabelProps, ref) => {
    return <StyledInputLabel className={hiddenLabel ? 'sr-only' : props.className} {...props} ref={ref} />;
  },
);
InputLabel.displayName = 'InputLabel';
